import * as types from '../constants/ActionTypes';

export function popupContributorStore(payload) {
  return {
    type: types.POPUP_CONTRIBUTOR,
    payload,
  };
}

export function popupPaymentStore(payload) {
  return {
    type: types.POPUP_PAYMENT,
    payload,
  };
}

export function selectPaymentEvent(payload) {
  return {
    type: types.SELECT_PAYMENT_EVENT,
    payload,
  };
}

export function savePreviousPath(payload) {
  return {
    type: types.PREVIOUS_PATH,
    payload,
  };
}

export function controlSidebar(payload) {
  return {
    type: types.CONTROL_SIDEBAR,
    payload,
  };
}



// WEBPACK FOOTER //
// ./src/actions/optionsStoreActions.js